import React, { useEffect, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { CTAButton } from '../ui'

const ProHero = ({ openContactModal }) => {

  return (
    <div className='lg:bg-hero-image bg-no-repeat lg:h-[450px] xl:h-[500px] 2xl:h-[680px] bg-contain bg-right'
    >
      <h1 className='lg:hidden text-[64px] font-bold text-left text-[#333] z-10 leading-tight'>
        あなたのビジネスの成長をサポートします!
      </h1>
      <h1 className='hidden lg:block text-[54px] xl:text-[64px] font-bold text-left text-[#333] z-10 lg:whitespace-pre-wrap'>
        {`あなたのビジネスの
成長をサポートしま`}<span className='bg-white'>す!</span>
      </h1>
      <p className='text-2xl text-left text-[#333] py-8 lg:py-8 xl:py-10 leading-170 lg:w-[22rem]'>
        Web制作から管理サポートまで全てお任せください！
      </p>
      <div className='z-0 absolute'>
        <CTAButton onClick={openContactModal}>今すぐ相談する</CTAButton>
      </div>
      <div className='pt-24 lg:hidden pb-10'>
        <StaticImage
          src='../../img/pro/all.webp'
          className='object-cover mt-6'
          alt='メインイメージ'
        />
      </div>
    </div>
  )
}

export default ProHero
